import { useQuery } from '@tanstack/react-query';
import { Pose } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function usePreorderPose(poseId) {
  return useQuery([QUERY_KEYS.POSES, poseId], () => (
    Pose
      .find(poseId)
      .then((res) => {
        if (res.data.url === 'PLACEHOLDER') {
          return res.data
        }
      })
  ), { enabled: !!poseId });
}
